module.exports = __webpack_public_path__ + "static/media/logo.66ad3242.svg";